import { LanguageId } from 'lib-knowledge-management-common/graphql';
import { z } from 'zod';

import { categorySchema } from '../../../collectionTree/components/categoryNode/modals/categoryEditModal/categoryEditModalSchema';

export const articleAddModalSchema = z.object({
  language: z.object({ id: z.nativeEnum(LanguageId), name: z.string() }),
  articleTitle: z.string().min(1, { message: 'Article title is required' }),
  collectionId: z.array(z.object({ id: z.string(), name: z.string() })),
  parentRef: categorySchema,
});
export type ArticleAddModalSchema = z.infer<typeof articleAddModalSchema>;
